/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDate: { input: string; output: string; }
  AWSDateTime: { input: string; output: string; }
  AWSEmail: { input: string; output: string; }
  AWSIPAddress: { input: string; output: string; }
  AWSJSON: { input: string; output: string; }
  AWSPhone: { input: string; output: string; }
  AWSTime: { input: string; output: string; }
  AWSTimestamp: { input: number; output: number; }
  AWSURL: { input: string; output: string; }
};

export enum ACCOUNT_USER_ROLE {
  ADMIN = 'ADMIN',
  EDITOR = 'EDITOR',
  OWNER = 'OWNER',
  VIEWER = 'VIEWER'
}

export enum ATTRIBUTE_FILTER_TYPE {
  BOOLEAN = 'BOOLEAN',
  DATE_RANGE = 'DATE_RANGE',
  ENUM_SELECTION = 'ENUM_SELECTION',
  NUMERIC_RANGE = 'NUMERIC_RANGE',
  TEXT_SEARCH = 'TEXT_SEARCH'
}

export type Account = {
  _accountUsers: Array<AccountUser>;
  _currentUserRole?: Maybe<ACCOUNT_USER_ROLE>;
  _recurlyAccountInfo?: Maybe<RecurlyAccountInfo>;
  companyName: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  paymentMethod?: Maybe<AccountPaymentMethod>;
  slug: Scalars['String']['output'];
  subdomain?: Maybe<Scalars['String']['output']>;
  subscription: AccountSubscription;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type AccountPaymentMethod = {
  cardCvv: Scalars['String']['output'];
  cardExpiresAt: Scalars['String']['output'];
  cardName: Scalars['String']['output'];
  cardNumber: Scalars['String']['output'];
};

export type AccountPaymentMethodInput = {
  cardCvv: Scalars['String']['input'];
  cardExpiresAt: Scalars['String']['input'];
  cardName: Scalars['String']['input'];
  cardNumber: Scalars['String']['input'];
};

export type AccountRecurlyInvoice = {
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  number: Scalars['String']['output'];
  state: RECURLY_INVOICE_STATE;
  total: Scalars['Float']['output'];
};

export type AccountRecurlyInvoicesCollection = {
  items: Array<AccountRecurlyInvoice>;
  total: Scalars['Int']['output'];
};

export type AccountSubscription = {
  paidConfig: AccountSubscriptionPaidConfig;
  trialExpiresAt?: Maybe<Scalars['AWSDateTime']['output']>;
  type: SUBSCRIPTION_TYPE;
};

export type AccountSubscriptionInput = {
  paidConfig: AccountSubscriptionPaidConfigInput;
  trialExpiresAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  type: SUBSCRIPTION_TYPE;
};

export type AccountSubscriptionPaidConfig = {
  addons: AccountSubscriptionPaidConfigAddons;
  cycle: SUBSCRIPTION_CYCLE;
  plan: SUBSCRIPTION_PLAN;
  subscriptionID?: Maybe<Scalars['String']['output']>;
};

export type AccountSubscriptionPaidConfigAddons = {
  admins: Scalars['Float']['output'];
  editors: Scalars['Float']['output'];
  maps: Scalars['Float']['output'];
  storage: Scalars['Float']['output'];
};

export type AccountSubscriptionPaidConfigAddonsInput = {
  admins: Scalars['Float']['input'];
  editors: Scalars['Float']['input'];
  maps: Scalars['Float']['input'];
  storage: Scalars['Float']['input'];
};

export type AccountSubscriptionPaidConfigInput = {
  addons: AccountSubscriptionPaidConfigAddonsInput;
  cycle: SUBSCRIPTION_CYCLE;
  plan: SUBSCRIPTION_PLAN;
};

export type AccountUsageStats = {
  admins: Scalars['Int']['output'];
  editors: Scalars['Int']['output'];
  maps: Scalars['Int']['output'];
  storage: Scalars['Float']['output'];
  viewers: Scalars['Int']['output'];
};

export type AccountUser = {
  _user: User;
  accountId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  role: ACCOUNT_USER_ROLE;
  updatedAt: Scalars['AWSDateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type AddDropboxDatasetSyncMetaDataInput = {
  files: Array<DropboxFileInput>;
  id: Scalars['ID']['input'];
};

export type AttributeFilterConfig = {
  filterType: ATTRIBUTE_FILTER_TYPE;
  propertyName: Scalars['String']['output'];
};

export type AttributeFilterConfigInput = {
  filterType: ATTRIBUTE_FILTER_TYPE;
  propertyName: Scalars['String']['input'];
};

export type AttributeFilterOptionInput = {
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type BasicSymbol = {
  opacity?: Maybe<Scalars['Float']['output']>;
  radius?: Maybe<Scalars['Float']['output']>;
  rotation?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
};

export type BasicSymbolInput = {
  opacity?: InputMaybe<Scalars['Float']['input']>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  rotation?: InputMaybe<Scalars['Float']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
};

export type BubbleConfigs = {
  classNumber?: Maybe<Scalars['Float']['output']>;
  classification?: Maybe<Scalars['String']['output']>;
  radius?: Maybe<PointBubbleRadius>;
  symbolStyle?: Maybe<SymbolStyle>;
  symbolValues?: Maybe<Array<SymbolValue>>;
  valueField?: Maybe<Scalars['String']['output']>;
};

export type BubbleConfigsInput = {
  classNumber?: InputMaybe<Scalars['Float']['input']>;
  classification?: InputMaybe<Scalars['String']['input']>;
  radius?: InputMaybe<PointBubbleRadiusInput>;
  symbolStyle?: InputMaybe<SymbolStyleInput>;
  symbolValues?: InputMaybe<Array<SymbolValueInput>>;
  valueField?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectDropboxTokenInput = {
  code: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type CreateLayerGroupInput = {
  mapId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
  visible: Scalars['Boolean']['input'];
};

export type CreateLayerInput = {
  bubbleStyle?: InputMaybe<BubbleConfigsInput>;
  dataType: GEOMETRY_TYPE;
  datasetId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  heatMapStyle?: InputMaybe<HeatMapConfigsInput>;
  labelsStyle?: InputMaybe<LabelsConfigsInput>;
  layerGroupId: Scalars['ID']['input'];
  lineCategoryStyle?: InputMaybe<LineCategoryConfigsInput>;
  lineQuantityStyle?: InputMaybe<LineQuantityConfigsInput>;
  lineSimpleStyle?: InputMaybe<LineSimpleConfigsInput>;
  maxZoom?: InputMaybe<Scalars['Float']['input']>;
  minZoom?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  pointCategoryStyle?: InputMaybe<PointCategoryConfigsInput>;
  pointQuantityStyle?: InputMaybe<PointQuantityConfigsInput>;
  pointSimpleStyle?: InputMaybe<PointSimpleConfigsInput>;
  polygonCategoryStyle?: InputMaybe<PolygonCategoryConfigsInput>;
  polygonQuantityStyle?: InputMaybe<PolygonQuantityConfigsInput>;
  polygonSimpleStyle?: InputMaybe<PolygonSimpleConfigsInput>;
  styleType: LAYER_STYLE_TYPE;
  visible: Scalars['Boolean']['input'];
};

export type CreateMapInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreatePaymentAccountInput = {
  billingToken: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  paidConfig: AccountSubscriptionPaidConfigInput;
  threeDToken?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePaymentAccountResults = {
  threeDSecureActionTokenId?: Maybe<Scalars['String']['output']>;
};

export type CreateSubdomainInput = {
  domain: Scalars['String']['input'];
};

export type CreateUserGroupInput = {
  name: Scalars['String']['input'];
};

export type CustomMakerIcon = {
  accountId: Scalars['String']['output'];
  iconUrl: Scalars['AWSURL']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  size: Scalars['String']['output'];
};

export type CustomMakerIconUploadUrlResult = {
  formFieldsJson: Scalars['AWSJSON']['output'];
  key: Scalars['String']['output'];
  uploadUrl: Scalars['AWSURL']['output'];
};

export enum DATASET_COLUMN_TYPE {
  BIGINT = 'BIGINT',
  BOOLEAN = 'BOOLEAN',
  CHAR = 'CHAR',
  DATE = 'DATE',
  DECIMAL = 'DECIMAL',
  DOUBLE_PRECISION = 'DOUBLE_PRECISION',
  GEOGRAPHY = 'GEOGRAPHY',
  GEOMETRY = 'GEOMETRY',
  GEOMETRYCOLLECTION = 'GEOMETRYCOLLECTION',
  INTEGER = 'INTEGER',
  INTERVAL = 'INTERVAL',
  JSON = 'JSON',
  JSONB = 'JSONB',
  LINESTRING = 'LINESTRING',
  MULTILINESTRING = 'MULTILINESTRING',
  MULTIPOINT = 'MULTIPOINT',
  MULTIPOLYGON = 'MULTIPOLYGON',
  NUMERIC = 'NUMERIC',
  POINT = 'POINT',
  POLYGON = 'POLYGON',
  REAL = 'REAL',
  SMALLINT = 'SMALLINT',
  TEXT = 'TEXT',
  TIME = 'TIME',
  TIMESTAMP = 'TIMESTAMP',
  TIMESTAMPTZ = 'TIMESTAMPTZ',
  UUID = 'UUID',
  VARCHAR = 'VARCHAR'
}

export enum DATASOURCE_TYPE {
  CSV = 'CSV',
  GEOJSON = 'GEOJSON',
  GEOTIFF = 'GEOTIFF',
  GEO_DATABASE = 'GEO_DATABASE',
  KML = 'KML',
  SHAPEFILE = 'SHAPEFILE',
  TAB = 'TAB',
  WMS = 'WMS'
}

export type Dataset = {
  _layers: Array<Layer>;
  _records: Array<DatasetRecord>;
  _recordsCount: Scalars['Int']['output'];
  accountId: Scalars['String']['output'];
  bbox: Array<Scalars['Float']['output']>;
  columns?: Maybe<Array<DatasetColumn>>;
  createdAt: Scalars['AWSDateTime']['output'];
  datasourceType: DATASOURCE_TYPE;
  description?: Maybe<Scalars['String']['output']>;
  dropboxAccessToken?: Maybe<Scalars['String']['output']>;
  dropboxFiles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  dropboxLatestCursor?: Maybe<Scalars['String']['output']>;
  dropboxRefreshToken?: Maybe<Scalars['String']['output']>;
  dropboxShareFilesLink?: Maybe<Scalars['String']['output']>;
  getCapabilitiesUrl?: Maybe<Scalars['AWSURL']['output']>;
  groupsAccesses: Array<DatasetGroupsAccess>;
  id: Scalars['ID']['output'];
  isAuthenticatedDropbox?: Maybe<Scalars['Boolean']['output']>;
  isPublic: Scalars['Boolean']['output'];
  isSyncActive: Scalars['Boolean']['output'];
  legendUrl?: Maybe<Scalars['AWSURL']['output']>;
  mapsCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Float']['output'];
  sourceDatasetId?: Maybe<Scalars['String']['output']>;
  type: GEOMETRY_TYPE;
  updatedAt: Scalars['AWSDateTime']['output'];
  userId: Scalars['ID']['output'];
};


export type Dataset_recordsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SORT_ORDER>;
};

export type DatasetColumn = {
  alias?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  domainName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nullable: Scalars['Boolean']['output'];
  precision?: Maybe<Scalars['Int']['output']>;
  subType?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  uniqueConstraint: Scalars['Boolean']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type DatasetGroupsAccess = {
  editable: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  viewable: Scalars['Boolean']['output'];
};

export type DatasetGroupsAccessInput = {
  editable: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  viewable: Scalars['Boolean']['input'];
};

export type DatasetRecord = {
  geometry?: Maybe<Scalars['AWSJSON']['output']>;
  gid: Scalars['Int']['output'];
  properties?: Maybe<Scalars['AWSJSON']['output']>;
};

export type DatasetSchema = {
  columns: Array<DatasetSchemaColumn>;
  tableName: Scalars['String']['output'];
};

export type DatasetSchemaColumn = {
  hasIndex: Scalars['Boolean']['output'];
  maxValue?: Maybe<Scalars['String']['output']>;
  minValue?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nullable: Scalars['Boolean']['output'];
  properties?: Maybe<Scalars['AWSJSON']['output']>;
  required: Scalars['Boolean']['output'];
  sampleValues?: Maybe<Array<Scalars['String']['output']>>;
  type: DATASET_COLUMN_TYPE;
  uniqueConstraint: Scalars['Boolean']['output'];
};

export type DomainValidationResult = {
  authorized: Scalars['Boolean']['output'];
  error?: Maybe<Scalars['String']['output']>;
};

export type DropboxFileInput = {
  bytes: Scalars['Int']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isDir?: InputMaybe<Scalars['Boolean']['input']>;
  link: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type Feature = {
  bbox?: Maybe<Array<Scalars['Float']['output']>>;
  gid: Scalars['Int']['output'];
  point?: Maybe<Array<Scalars['Float']['output']>>;
  properties: Scalars['AWSJSON']['output'];
};

export type FileUploadUrlResult = {
  formFieldsJson: Scalars['AWSJSON']['output'];
  uploadUrl: Scalars['AWSURL']['output'];
};

export type FillStyle = {
  color?: Maybe<Scalars['String']['output']>;
  fillType?: Maybe<Scalars['String']['output']>;
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  opacity?: Maybe<Scalars['Float']['output']>;
  style?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type FillStyleInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  fillType?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  opacity?: InputMaybe<Scalars['Float']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export enum GEOMETRY_TYPE {
  LINE = 'LINE',
  POINT = 'POINT',
  POLYGON = 'POLYGON',
  RASTER = 'RASTER',
  WMS = 'WMS'
}

export enum GET_DATASET_ACCESS_METHOD_TYPE {
  AUTHORIZED_USER = 'AUTHORIZED_USER',
  NOT_FOUND = 'NOT_FOUND',
  PUBLIC = 'PUBLIC'
}

export enum GET_MAP_ACCESS_METHOD_TYPE {
  AUTHORIZED_USER = 'AUTHORIZED_USER',
  HIDDEN_ID = 'HIDDEN_ID',
  NOT_FOUND = 'NOT_FOUND',
  PASSWORD = 'PASSWORD',
  PUBLIC = 'PUBLIC'
}

export type GenerateClassbreaksInput = {
  classNumber: Scalars['Float']['input'];
  classification: Scalars['String']['input'];
  columnName: Scalars['String']['input'];
  tableName: Scalars['String']['input'];
};

export type GetDatasetAccessMethodResults = {
  type: GET_DATASET_ACCESS_METHOD_TYPE;
};

export type GetMapAccessMethodResults = {
  type: GET_MAP_ACCESS_METHOD_TYPE;
};

export type GetUniqueValuesInput = {
  columnName: Scalars['String']['input'];
  tableName: Scalars['String']['input'];
};

export type HeatMapBasicConfigs = {
  opacity?: Maybe<Scalars['Float']['output']>;
  radius?: Maybe<Scalars['Float']['output']>;
};

export type HeatMapBasicConfigsInput = {
  opacity?: InputMaybe<Scalars['Float']['input']>;
  radius?: InputMaybe<Scalars['Float']['input']>;
};

export type HeatMapConfigs = {
  basic?: Maybe<HeatMapBasicConfigs>;
};

export type HeatMapConfigsInput = {
  basic?: InputMaybe<HeatMapBasicConfigsInput>;
};

export type InviteUserInput = {
  email: Scalars['String']['input'];
  groupIds: Array<Scalars['ID']['input']>;
  role: ACCOUNT_USER_ROLE;
};

export type JoinAccountInput = {
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export enum LAYER_STYLE_TYPE {
  BUBBLE = 'BUBBLE',
  HEATMAP = 'HEATMAP',
  LINE_CATEGORY = 'LINE_CATEGORY',
  LINE_QUANTITY = 'LINE_QUANTITY',
  LINE_SIMPLE = 'LINE_SIMPLE',
  POINT_CATEGORY = 'POINT_CATEGORY',
  POINT_QUANTITY = 'POINT_QUANTITY',
  POINT_SIMPLE = 'POINT_SIMPLE',
  POLYGON_CATEGORY = 'POLYGON_CATEGORY',
  POLYGON_QUANTITY = 'POLYGON_QUANTITY',
  POLYGON_SIMPLE = 'POLYGON_SIMPLE',
  RASTER = 'RASTER',
  WMS = 'WMS'
}

export type LabelsConfigs = {
  attribute?: Maybe<Scalars['String']['output']>;
  font?: Maybe<Scalars['String']['output']>;
  fontColour?: Maybe<Scalars['String']['output']>;
  fontOpacity?: Maybe<Scalars['Float']['output']>;
  fontSize?: Maybe<Scalars['Float']['output']>;
  haloColour?: Maybe<Scalars['String']['output']>;
  haloOpacity?: Maybe<Scalars['Float']['output']>;
  haloSize?: Maybe<Scalars['Float']['output']>;
};

export type LabelsConfigsInput = {
  attribute?: InputMaybe<Scalars['String']['input']>;
  font?: InputMaybe<Scalars['String']['input']>;
  fontColour?: InputMaybe<Scalars['String']['input']>;
  fontOpacity?: InputMaybe<Scalars['Float']['input']>;
  fontSize?: InputMaybe<Scalars['Float']['input']>;
  haloColour?: InputMaybe<Scalars['String']['input']>;
  haloOpacity?: InputMaybe<Scalars['Float']['input']>;
  haloSize?: InputMaybe<Scalars['Float']['input']>;
};

export type Layer = {
  _dataset: Dataset;
  _layerGroup: LayerGroup;
  bubbleStyle?: Maybe<BubbleConfigs>;
  createdAt: Scalars['AWSDateTime']['output'];
  dataType: GEOMETRY_TYPE;
  datasetId: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  heatMapStyle?: Maybe<HeatMapConfigs>;
  id: Scalars['ID']['output'];
  labelsStyle?: Maybe<LabelsConfigs>;
  layerGroupId: Scalars['ID']['output'];
  lineCategoryStyle?: Maybe<LineCategoryConfigs>;
  lineQuantityStyle?: Maybe<LineQuantityConfigs>;
  lineSimpleStyle?: Maybe<LineSimpleConfigs>;
  maxZoom?: Maybe<Scalars['Float']['output']>;
  minZoom?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  pointCategoryStyle?: Maybe<PointCategoryConfigs>;
  pointQuantityStyle?: Maybe<PointQuantityConfigs>;
  pointSimpleStyle?: Maybe<PointSimpleConfigs>;
  polygonCategoryStyle?: Maybe<PolygonCategoryConfigs>;
  polygonQuantityStyle?: Maybe<PolygonQuantityConfigs>;
  polygonSimpleStyle?: Maybe<PolygonSimpleConfigs>;
  position: Scalars['Int']['output'];
  styleType: LAYER_STYLE_TYPE;
  updatedAt: Scalars['AWSDateTime']['output'];
  visible: Scalars['Boolean']['output'];
};

export type LayerCollection = {
  items: Array<Layer>;
  total: Scalars['Int']['output'];
};

export type LayerConfiguration = {
  _layer: Layer;
  attributeFilters: Array<AttributeFilterConfig>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isReportEnabled: Scalars['Boolean']['output'];
  isResultsTableEnabled: Scalars['Boolean']['output'];
  layerId: Scalars['ID']['output'];
  measurementUnit: MEASUREMENT_UNIT;
  outputSettings: OutputSettings;
  reportContent?: Maybe<Scalars['String']['output']>;
  spatialFilters: SpatialFilterConfig;
  title: Scalars['String']['output'];
};

export type LayerConfigurationInput = {
  attributeFilters: Array<AttributeFilterConfigInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isReportEnabled: Scalars['Boolean']['input'];
  isResultsTableEnabled: Scalars['Boolean']['input'];
  layerId: Scalars['ID']['input'];
  measurementUnit: MEASUREMENT_UNIT;
  outputSettings: OutputSettingsInput;
  reportContent?: InputMaybe<Scalars['String']['input']>;
  spatialFilters: SpatialFilterConfigInput;
  title: Scalars['String']['input'];
};

export type LayerGroup = {
  _map: Map;
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  layerCollection: LayerCollection;
  mapId: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  visible: Scalars['Boolean']['output'];
};

export type LayerGroupCollection = {
  items: Array<LayerGroup>;
  total: Scalars['Int']['output'];
};

export type LineCategoryConfigs = {
  colorRamp?: Maybe<Scalars['String']['output']>;
  isSymbolValuesCustomised?: Maybe<Scalars['Boolean']['output']>;
  symbolStyle?: Maybe<SymbolStyle>;
  symbolValues?: Maybe<Array<SymbolValue>>;
  valueField?: Maybe<Scalars['String']['output']>;
};

export type LineCategoryConfigsInput = {
  colorRamp?: InputMaybe<Scalars['String']['input']>;
  isSymbolValuesCustomised?: InputMaybe<Scalars['Boolean']['input']>;
  symbolStyle?: InputMaybe<SymbolStyleInput>;
  symbolValues?: InputMaybe<Array<SymbolValueInput>>;
  valueField?: InputMaybe<Scalars['String']['input']>;
};

export type LineQuantityConfigs = {
  classNumber?: Maybe<Scalars['Float']['output']>;
  classbreaks?: Maybe<Array<Scalars['Float']['output']>>;
  classification?: Maybe<Scalars['String']['output']>;
  colorRamp?: Maybe<Scalars['String']['output']>;
  isSymbolValuesCustomised?: Maybe<Scalars['Boolean']['output']>;
  legendType?: Maybe<Scalars['String']['output']>;
  symbolStyle?: Maybe<SymbolStyle>;
  symbolValues?: Maybe<Array<SymbolValue>>;
  valueField?: Maybe<Scalars['String']['output']>;
};

export type LineQuantityConfigsInput = {
  classNumber?: InputMaybe<Scalars['Float']['input']>;
  classbreaks?: InputMaybe<Array<Scalars['Float']['input']>>;
  classification?: InputMaybe<Scalars['String']['input']>;
  colorRamp?: InputMaybe<Scalars['String']['input']>;
  isSymbolValuesCustomised?: InputMaybe<Scalars['Boolean']['input']>;
  legendType?: InputMaybe<Scalars['String']['input']>;
  symbolStyle?: InputMaybe<SymbolStyleInput>;
  symbolValues?: InputMaybe<Array<SymbolValueInput>>;
  valueField?: InputMaybe<Scalars['String']['input']>;
};

export type LineSimpleConfigs = {
  symbolStyle?: Maybe<SymbolStyle>;
};

export type LineSimpleConfigsInput = {
  symbolStyle?: InputMaybe<SymbolStyleInput>;
};

export enum MAP_EMBED_LOAD_TYPE {
  CURRENT = 'CURRENT',
  DEFAULT = 'DEFAULT'
}

export enum MAP_PUBLIC_ACCESS_TYPE {
  ANYONE = 'ANYONE',
  HIDDEN = 'HIDDEN',
  PASSWORD = 'PASSWORD',
  STANDALONE = 'STANDALONE'
}

export enum MEASUREMENT_UNIT {
  FEET = 'FEET',
  KILOMETERS = 'KILOMETERS',
  METERS = 'METERS',
  MILES = 'MILES'
}

export type Map = {
  accountId: Scalars['ID']['output'];
  baseMapId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  embedConfigs: MapEmbedConfig;
  groupsAccesses: Array<MapGroupsAccess>;
  id: Scalars['ID']['output'];
  isPublic: Scalars['Boolean']['output'];
  layerGroupCollection: LayerGroupCollection;
  name: Scalars['String']['output'];
  publicAccessConfigs?: Maybe<MapPublicAccessConfig>;
  tool?: Maybe<MapTool>;
  updatedAt: Scalars['AWSDateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type MapEmbedConfig = {
  loadType: MAP_EMBED_LOAD_TYPE;
  mapConfigs?: Maybe<Scalars['AWSJSON']['output']>;
};

export type MapEmbedConfigInput = {
  loadType: MAP_EMBED_LOAD_TYPE;
  mapConfigs?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export type MapGroupsAccess = {
  editable: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  viewable: Scalars['Boolean']['output'];
};

export type MapGroupsAccessInput = {
  editable: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  viewable: Scalars['Boolean']['input'];
};

export type MapPublicAccessConfig = {
  hiddenId?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  type: MAP_PUBLIC_ACCESS_TYPE;
};

export type MapPublicAccessConfigInput = {
  hiddenId?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  type: MAP_PUBLIC_ACCESS_TYPE;
};

export type MapQueryConfiguration = {
  color: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  layerConfigurations: Array<LayerConfiguration>;
  mapId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type MapQueryConfigurationInput = {
  color: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  layerConfigurations: Array<LayerConfigurationInput>;
  mapId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type MapTool = {
  bookmarks?: Maybe<Scalars['Boolean']['output']>;
  customSearch?: Maybe<Scalars['Boolean']['output']>;
  geolocation?: Maybe<Scalars['Boolean']['output']>;
  legend?: Maybe<Scalars['Boolean']['output']>;
  measure?: Maybe<Scalars['Boolean']['output']>;
  mousePosition?: Maybe<Scalars['Boolean']['output']>;
  print?: Maybe<Scalars['Boolean']['output']>;
  proximity?: Maybe<Scalars['Boolean']['output']>;
  query?: Maybe<Scalars['Boolean']['output']>;
  resetMap?: Maybe<Scalars['Boolean']['output']>;
  scaleBar?: Maybe<Scalars['Boolean']['output']>;
  search?: Maybe<Scalars['Boolean']['output']>;
  shareMap?: Maybe<Scalars['Boolean']['output']>;
  sketch?: Maybe<Scalars['Boolean']['output']>;
  streetView?: Maybe<Scalars['Boolean']['output']>;
};

export type Mutation = {
  addDropboxDatasetSyncMetaData: Dataset;
  cancelSubscriptionAccount: Account;
  connectDropboxGetRefreshToken: Scalars['Boolean']['output'];
  createLayer: Layer;
  createLayerGroup: LayerGroup;
  createMap: Map;
  createMapQueryConfiguration: MapQueryConfiguration;
  createPaymentAccount: CreatePaymentAccountResults;
  createSubdomain: Scalars['String']['output'];
  createUserGroup: UserGroup;
  deleteAccountUser: AccountUser;
  deleteDataset: Dataset;
  deleteLayer: Layer;
  deleteLayerGroup: LayerGroup;
  deleteMap: Map;
  deleteMapQueryConfiguration: Scalars['Boolean']['output'];
  deleteSubdomain: Scalars['Boolean']['output'];
  deleteUserGroup: UserGroup;
  disconnectDropbox: Scalars['Boolean']['output'];
  generateClassbreaks: Array<Scalars['Float']['output']>;
  generateSpatialQueryDownloadLink: Scalars['AWSURL']['output'];
  getUniqueValues: Scalars['AWSJSON']['output'];
  inviteUser: Scalars['Boolean']['output'];
  isEmailTaken: Scalars['Boolean']['output'];
  joinAccount: User;
  previewSubscriptionChange: PreviewSubscriptionChangeResults;
  processGeotiffDataset: ProcessGeotiffDatasetResults;
  processTempDataset: ProcessTempDatasetResults;
  processWmsDataset: ProcessWmsDatasetResults;
  submitContactForm: Scalars['Boolean']['output'];
  submitFranchiseContactForm: Scalars['Boolean']['output'];
  triggerGeotiffProcessingComplete: TriggerGeotiffProcessingCompleteResults;
  triggerGeotiffProcessingError: TriggerGeotiffProcessingErrorResults;
  updateAccountUser: AccountUser;
  updateCurrentAccount: Account;
  updateCurrentUser: User;
  updateDataset: Dataset;
  updateLayer: Layer;
  updateLayerGroup: LayerGroup;
  updateLayerPosition: Layer;
  updateMap: Map;
  updateMapQueryConfiguration: MapQueryConfiguration;
  updateSubscriptionAccount: Account;
  updateUser: User;
  updateUserGroup: UserGroup;
};


export type MutationaddDropboxDatasetSyncMetaDataArgs = {
  input?: InputMaybe<AddDropboxDatasetSyncMetaDataInput>;
};


export type MutationcancelSubscriptionAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationconnectDropboxGetRefreshTokenArgs = {
  input: ConnectDropboxTokenInput;
};


export type MutationcreateLayerArgs = {
  input: CreateLayerInput;
};


export type MutationcreateLayerGroupArgs = {
  input: CreateLayerGroupInput;
};


export type MutationcreateMapArgs = {
  input: CreateMapInput;
};


export type MutationcreateMapQueryConfigurationArgs = {
  input: MapQueryConfigurationInput;
};


export type MutationcreatePaymentAccountArgs = {
  input: CreatePaymentAccountInput;
};


export type MutationcreateSubdomainArgs = {
  input: CreateSubdomainInput;
};


export type MutationcreateUserGroupArgs = {
  input: CreateUserGroupInput;
  memberIds: Array<Scalars['ID']['input']>;
};


export type MutationdeleteAccountUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationdeleteDatasetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationdeleteLayerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationdeleteLayerGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationdeleteMapArgs = {
  id: Scalars['ID']['input'];
};


export type MutationdeleteMapQueryConfigurationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationdeleteUserGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationdisconnectDropboxArgs = {
  id: Scalars['ID']['input'];
};


export type MutationgenerateClassbreaksArgs = {
  input: GenerateClassbreaksInput;
};


export type MutationgenerateSpatialQueryDownloadLinkArgs = {
  format: OUTPUT_FORMAT;
  input: SpatialQueryInput;
};


export type MutationgetUniqueValuesArgs = {
  input: GetUniqueValuesInput;
};


export type MutationinviteUserArgs = {
  input: InviteUserInput;
};


export type MutationisEmailTakenArgs = {
  email: Scalars['String']['input'];
};


export type MutationjoinAccountArgs = {
  input: JoinAccountInput;
};


export type MutationpreviewSubscriptionChangeArgs = {
  input: PreviewSubscriptionChangeInput;
};


export type MutationprocessGeotiffDatasetArgs = {
  input: ProcessGeotiffDatasetInput;
};


export type MutationprocessTempDatasetArgs = {
  input: ProcessTempDatasetInput;
};


export type MutationprocessWmsDatasetArgs = {
  input: ProcessWmsDatasetInput;
};


export type MutationsubmitContactFormArgs = {
  input: SubmitContactFormInput;
  recaptchaToken: Scalars['String']['input'];
};


export type MutationsubmitFranchiseContactFormArgs = {
  input: SubmitFranchiseContactFormInput;
  recaptchaToken: Scalars['String']['input'];
};


export type MutationtriggerGeotiffProcessingCompleteArgs = {
  input: TriggerGeotiffProcessingCompleteInput;
};


export type MutationtriggerGeotiffProcessingErrorArgs = {
  input: TriggerGeotiffProcessingErrorInput;
};


export type MutationupdateAccountUserArgs = {
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  role?: InputMaybe<ACCOUNT_USER_ROLE>;
};


export type MutationupdateCurrentAccountArgs = {
  input: UpdateAccountInput;
};


export type MutationupdateCurrentUserArgs = {
  input: UpdateUserInput;
};


export type MutationupdateDatasetArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDatasetInput;
};


export type MutationupdateLayerArgs = {
  input: UpdateLayerInput;
};


export type MutationupdateLayerGroupArgs = {
  input: UpdateLayerGroupInput;
};


export type MutationupdateLayerPositionArgs = {
  id: Scalars['ID']['input'];
  newGroupId?: InputMaybe<Scalars['ID']['input']>;
  newPosition: Scalars['Int']['input'];
};


export type MutationupdateMapArgs = {
  input: UpdateMapInput;
};


export type MutationupdateMapQueryConfigurationArgs = {
  id: Scalars['ID']['input'];
  input: MapQueryConfigurationInput;
};


export type MutationupdateSubscriptionAccountArgs = {
  input: UpdateSubscriptionAccountInput;
};


export type MutationupdateUserArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUserInput;
};


export type MutationupdateUserGroupArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUserGroupInput;
  memberIds: Array<Scalars['ID']['input']>;
};

export enum OUTPUT_FORMAT {
  CSV = 'CSV',
  KML = 'KML',
  SHAPEFILE = 'SHAPEFILE'
}

export type OutputSettings = {
  allowedFormats: Array<OUTPUT_FORMAT>;
  includeGeometry: Scalars['Boolean']['output'];
};

export type OutputSettingsInput = {
  allowedFormats: Array<OUTPUT_FORMAT>;
  includeGeometry: Scalars['Boolean']['input'];
};

export enum PROPERTY_OPERATOR {
  CONTAINS = 'CONTAINS',
  ENDS_WITH = 'ENDS_WITH',
  EQ = 'EQ',
  GT = 'GT',
  GTE = 'GTE',
  IN = 'IN',
  LT = 'LT',
  LTE = 'LTE',
  NE = 'NE',
  NIN = 'NIN',
  STARTS_WITH = 'STARTS_WITH'
}

export type PointBubbleRadius = {
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

export type PointBubbleRadiusInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type PointCategoryConfigs = {
  colorRamp?: Maybe<Scalars['String']['output']>;
  isSymbolValuesCustomised?: Maybe<Scalars['Boolean']['output']>;
  symbolStyle?: Maybe<SymbolStyle>;
  symbolValues?: Maybe<Array<SymbolValue>>;
  valueField?: Maybe<Scalars['String']['output']>;
};

export type PointCategoryConfigsInput = {
  colorRamp?: InputMaybe<Scalars['String']['input']>;
  isSymbolValuesCustomised?: InputMaybe<Scalars['Boolean']['input']>;
  symbolStyle?: InputMaybe<SymbolStyleInput>;
  symbolValues?: InputMaybe<Array<SymbolValueInput>>;
  valueField?: InputMaybe<Scalars['String']['input']>;
};

export type PointQuantityConfigs = {
  classNumber?: Maybe<Scalars['Float']['output']>;
  classbreaks?: Maybe<Array<Scalars['Float']['output']>>;
  classification?: Maybe<Scalars['String']['output']>;
  colorRamp?: Maybe<Scalars['String']['output']>;
  isSymbolValuesCustomised?: Maybe<Scalars['Boolean']['output']>;
  legendType?: Maybe<Scalars['String']['output']>;
  symbolStyle?: Maybe<SymbolStyle>;
  symbolValues?: Maybe<Array<SymbolValue>>;
  valueField?: Maybe<Scalars['String']['output']>;
};

export type PointQuantityConfigsInput = {
  classNumber?: InputMaybe<Scalars['Float']['input']>;
  classbreaks?: InputMaybe<Array<Scalars['Float']['input']>>;
  classification?: InputMaybe<Scalars['String']['input']>;
  colorRamp?: InputMaybe<Scalars['String']['input']>;
  isSymbolValuesCustomised?: InputMaybe<Scalars['Boolean']['input']>;
  legendType?: InputMaybe<Scalars['String']['input']>;
  symbolStyle?: InputMaybe<SymbolStyleInput>;
  symbolValues?: InputMaybe<Array<SymbolValueInput>>;
  valueField?: InputMaybe<Scalars['String']['input']>;
};

export type PointSimpleConfigs = {
  symbolStyle?: Maybe<SymbolStyle>;
};

export type PointSimpleConfigsInput = {
  symbolStyle?: InputMaybe<SymbolStyleInput>;
};

export type PolygonCategoryConfigs = {
  colorRamp?: Maybe<Scalars['String']['output']>;
  isSymbolValuesCustomised?: Maybe<Scalars['Boolean']['output']>;
  symbolStyle?: Maybe<SymbolStyle>;
  symbolValues?: Maybe<Array<SymbolValue>>;
  valueField?: Maybe<Scalars['String']['output']>;
};

export type PolygonCategoryConfigsInput = {
  colorRamp?: InputMaybe<Scalars['String']['input']>;
  isSymbolValuesCustomised?: InputMaybe<Scalars['Boolean']['input']>;
  symbolStyle?: InputMaybe<SymbolStyleInput>;
  symbolValues?: InputMaybe<Array<SymbolValueInput>>;
  valueField?: InputMaybe<Scalars['String']['input']>;
};

export type PolygonQuantityConfigs = {
  classNumber?: Maybe<Scalars['Float']['output']>;
  classbreaks?: Maybe<Array<Scalars['Float']['output']>>;
  classification?: Maybe<Scalars['String']['output']>;
  colorRamp?: Maybe<Scalars['String']['output']>;
  isSymbolValuesCustomised?: Maybe<Scalars['Boolean']['output']>;
  legendType?: Maybe<Scalars['String']['output']>;
  symbolStyle?: Maybe<SymbolStyle>;
  symbolValues?: Maybe<Array<SymbolValue>>;
  valueField?: Maybe<Scalars['String']['output']>;
};

export type PolygonQuantityConfigsInput = {
  classNumber?: InputMaybe<Scalars['Float']['input']>;
  classbreaks?: InputMaybe<Array<Scalars['Float']['input']>>;
  classification?: InputMaybe<Scalars['String']['input']>;
  colorRamp?: InputMaybe<Scalars['String']['input']>;
  isSymbolValuesCustomised?: InputMaybe<Scalars['Boolean']['input']>;
  legendType?: InputMaybe<Scalars['String']['input']>;
  symbolStyle?: InputMaybe<SymbolStyleInput>;
  symbolValues?: InputMaybe<Array<SymbolValueInput>>;
  valueField?: InputMaybe<Scalars['String']['input']>;
};

export type PolygonSimpleConfigs = {
  symbolStyle?: Maybe<SymbolStyle>;
};

export type PolygonSimpleConfigsInput = {
  symbolStyle?: InputMaybe<SymbolStyleInput>;
};

export type PreviewSubscriptionChangeInput = {
  id: Scalars['ID']['input'];
  paidConfig: AccountSubscriptionPaidConfigInput;
};

export type PreviewSubscriptionChangeResults = {
  chargeTotal?: Maybe<Scalars['Float']['output']>;
  creditTotal?: Maybe<Scalars['Float']['output']>;
};

export type ProcessGeotiffDatasetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type ProcessGeotiffDatasetResults = {
  subscriptionId: Scalars['ID']['output'];
};

export type ProcessTempDatasetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type ProcessTempDatasetLayerError = {
  error: Scalars['String']['output'];
  sourceLayerName: Scalars['String']['output'];
};

export type ProcessTempDatasetResults = {
  createdDatasets: Array<Dataset>;
  errors: Array<ProcessTempDatasetLayerError>;
};

export type ProcessWmsDatasetInput = {
  getCapabilitiesUrl: Scalars['AWSURL']['input'];
  layers: Array<ProcessWmsDatasetLayerInput>;
};

export type ProcessWmsDatasetLayerInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  extent: Array<Scalars['Float']['input']>;
  legendUrl?: InputMaybe<Scalars['AWSURL']['input']>;
  name: Scalars['String']['input'];
};

export type ProcessWmsDatasetResults = {
  createdDatasets: Array<Dataset>;
  errors: Array<ProcessTempDatasetLayerError>;
};

export type PropertyFilter = {
  field: Scalars['String']['input'];
  operator: PROPERTY_OPERATOR;
  value: Scalars['AWSJSON']['input'];
};

export type Query = {
  getAccountUser: AccountUser;
  getCurrentAccount: Account;
  getCurrentAccountSubdomain?: Maybe<Scalars['String']['output']>;
  getCurrentAccountUsageStats: AccountUsageStats;
  getCurrentUser: User;
  getCustomMakerIcons: Array<CustomMakerIcon>;
  getDatasetAccessMethod: GetDatasetAccessMethodResults;
  getDatasetByAdmin: Dataset;
  getDatasetByAuthorizedUser: Dataset;
  getDatasetByPublic: Dataset;
  getDatasetSchema: DatasetSchema;
  getDatasets: Array<Dataset>;
  getLayer: Layer;
  getMapAccessMethod: GetMapAccessMethodResults;
  getMapByAdmin: Map;
  getMapByAuthorizedUser: Map;
  getMapByHiddenId: Map;
  getMapByPassword: Map;
  getMapByPublic: Map;
  getMapQueryConfigurationByMap: MapQueryConfiguration;
  getMaps: Array<Map>;
  getRecurlyInvoices: AccountRecurlyInvoicesCollection;
  getTempCustomMakerIconUploadUrl: CustomMakerIconUploadUrlResult;
  getTempDatasetUploadUrl: FileUploadUrlResult;
  getUser: User;
  getUserGroup: UserGroup;
  getUserGroups: Array<UserGroup>;
  spatialQueryGids: SpatialQueryGidsResult;
  spatialQueryProperties: SpatialQueryPropertiesResult;
  spatialQueryReports: SpatialQueryReportsResult;
  validateDomain: DomainValidationResult;
};


export type QuerygetAccountUserArgs = {
  id: Scalars['ID']['input'];
};


export type QuerygetDatasetAccessMethodArgs = {
  id: Scalars['ID']['input'];
};


export type QuerygetDatasetByAdminArgs = {
  id: Scalars['ID']['input'];
};


export type QuerygetDatasetByAuthorizedUserArgs = {
  id: Scalars['ID']['input'];
};


export type QuerygetDatasetByPublicArgs = {
  id: Scalars['ID']['input'];
};


export type QuerygetDatasetSchemaArgs = {
  tableName: Scalars['String']['input'];
};


export type QuerygetLayerArgs = {
  id: Scalars['ID']['input'];
};


export type QuerygetMapAccessMethodArgs = {
  id: Scalars['ID']['input'];
};


export type QuerygetMapByAdminArgs = {
  id: Scalars['ID']['input'];
};


export type QuerygetMapByAuthorizedUserArgs = {
  id: Scalars['ID']['input'];
};


export type QuerygetMapByHiddenIdArgs = {
  id: Scalars['ID']['input'];
};


export type QuerygetMapByPasswordArgs = {
  id: Scalars['ID']['input'];
  password: Scalars['String']['input'];
};


export type QuerygetMapByPublicArgs = {
  id: Scalars['ID']['input'];
};


export type QuerygetMapQueryConfigurationByMapArgs = {
  mapId: Scalars['ID']['input'];
};


export type QuerygetRecurlyInvoicesArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QuerygetTempCustomMakerIconUploadUrlArgs = {
  extension: Scalars['String']['input'];
};


export type QuerygetTempDatasetUploadUrlArgs = {
  extension: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type QuerygetUserArgs = {
  id: Scalars['ID']['input'];
};


export type QuerygetUserGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryspatialQueryGidsArgs = {
  input: SpatialQueryInput;
};


export type QueryspatialQueryPropertiesArgs = {
  input: SpatialQueryInput;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryspatialQueryReportsArgs = {
  input: SpatialQueryInput;
  mapId: Scalars['ID']['input'];
  queryId: Scalars['ID']['input'];
};


export type QueryvalidateDomainArgs = {
  host: Scalars['String']['input'];
};

export enum RECURLY_INVOICE_STATE {
  closed = 'closed',
  failed = 'failed',
  open = 'open',
  paid = 'paid',
  past_due = 'past_due',
  pending = 'pending',
  processing = 'processing',
  voided = 'voided'
}

export type RecurlyAccountInfo = {
  balanceAmount?: Maybe<Scalars['Float']['output']>;
  billingAddress?: Maybe<RecurlyBillingAddress>;
  hostedToken?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<RecurlyPaymentMethod>;
  subscription?: Maybe<RecurlySubscription>;
};

export type RecurlyBillingAddress = {
  city?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  streetLine1?: Maybe<Scalars['String']['output']>;
  streetLine2?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
};

export type RecurlyPaymentMethod = {
  cardType?: Maybe<Scalars['String']['output']>;
  expMonth?: Maybe<Scalars['Float']['output']>;
  expYear?: Maybe<Scalars['Float']['output']>;
  lastFour?: Maybe<Scalars['String']['output']>;
};

export type RecurlySubscription = {
  addOns?: Maybe<Array<RecurlySubscriptionAddOn>>;
  collectionMethod?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<Scalars['String']['output']>;
};

export type RecurlySubscriptionAddOn = {
  code?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

export enum SORT_ORDER {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum SPATIAL_FILTER_TYPE {
  ALL = 'ALL',
  CIRCLE = 'CIRCLE',
  POINT = 'POINT',
  POLYGON = 'POLYGON',
  RECTANGLE = 'RECTANGLE'
}

export enum SPATIAL_RELATION {
  CONTAINS = 'CONTAINS',
  CROSSES = 'CROSSES',
  DISJOINT = 'DISJOINT',
  DWITHIN = 'DWITHIN',
  INTERSECTS = 'INTERSECTS',
  OVERLAPS = 'OVERLAPS',
  TOUCHES = 'TOUCHES',
  WITHIN = 'WITHIN'
}

export enum SUBSCRIPTION_CYCLE {
  ANNUAL = 'ANNUAL',
  FIVE_YEARS = 'FIVE_YEARS',
  FOUR_YEARS = 'FOUR_YEARS',
  MONTHLY = 'MONTHLY',
  THREE_YEARS = 'THREE_YEARS',
  TWO_YEARS = 'TWO_YEARS'
}

export enum SUBSCRIPTION_PLAN {
  AGENCY = 'AGENCY',
  BUSINESS = 'BUSINESS',
  ENTERPRISE = 'ENTERPRISE'
}

export enum SUBSCRIPTION_TYPE {
  CLOSED = 'CLOSED',
  PAID = 'PAID',
  TRIAL = 'TRIAL'
}

export type SpatialFilterConfig = {
  allowedTypes: Array<SPATIAL_FILTER_TYPE>;
  enabled: Scalars['Boolean']['output'];
};

export type SpatialFilterConfigInput = {
  allowedTypes: Array<SPATIAL_FILTER_TYPE>;
  enabled: Scalars['Boolean']['input'];
};

export type SpatialQueryGidsResult = {
  bbox?: Maybe<Array<Scalars['Float']['output']>>;
  gids: Array<Scalars['Int']['output']>;
  processTime?: Maybe<Scalars['Float']['output']>;
};

export type SpatialQueryInput = {
  datasetId: Scalars['ID']['input'];
  distance?: InputMaybe<Scalars['Float']['input']>;
  distanceUnit?: InputMaybe<MEASUREMENT_UNIT>;
  geometry?: InputMaybe<Scalars['String']['input']>;
  gids: Array<Scalars['Int']['input']>;
  properties: Array<PropertyFilter>;
  relation?: InputMaybe<SPATIAL_RELATION>;
};

export type SpatialQueryPropertiesResult = {
  items: Array<Feature>;
  processTime?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Int']['output'];
};

export type SpatialQueryReportsResult = {
  content?: Maybe<Scalars['String']['output']>;
  processTime?: Maybe<Scalars['Float']['output']>;
};

export type StrokeStyle = {
  color?: Maybe<Scalars['String']['output']>;
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  opacity?: Maybe<Scalars['Float']['output']>;
  style?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type StrokeStyleInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  opacity?: InputMaybe<Scalars['Float']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type SubmitContactFormInput = {
  company: Scalars['String']['input'];
  email: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  source: Scalars['String']['input'];
  sourceDetails?: InputMaybe<Scalars['String']['input']>;
  teamSize: Scalars['String']['input'];
};

export type SubmitFranchiseContactFormInput = {
  company: Scalars['String']['input'];
  email: Scalars['String']['input'];
  goalNumber: Scalars['String']['input'];
  isRegistered: Scalars['Boolean']['input'];
  locations: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  source: Scalars['String']['input'];
  sourceDetails?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  onGeotiffProcessingComplete?: Maybe<TriggerGeotiffProcessingCompleteResults>;
  onGeotiffProcessingError?: Maybe<TriggerGeotiffProcessingErrorResults>;
};


export type SubscriptiononGeotiffProcessingCompleteArgs = {
  subscriptionId: Scalars['ID']['input'];
};


export type SubscriptiononGeotiffProcessingErrorArgs = {
  subscriptionId: Scalars['ID']['input'];
};

export type SymbolStyle = {
  basic?: Maybe<BasicSymbol>;
  fill?: Maybe<FillStyle>;
  isGraphic?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  stroke?: Maybe<StrokeStyle>;
};

export type SymbolStyleInput = {
  basic?: InputMaybe<BasicSymbolInput>;
  fill?: InputMaybe<FillStyleInput>;
  isGraphic?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  stroke?: InputMaybe<StrokeStyleInput>;
};

export type SymbolValue = {
  color?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  legendVisibility?: Maybe<Scalars['Boolean']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  range?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<SymbolStyle>;
  value?: Maybe<Scalars['String']['output']>;
};

export type SymbolValueInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  legendVisibility?: InputMaybe<Scalars['Boolean']['input']>;
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  range?: InputMaybe<Scalars['String']['input']>;
  symbol?: InputMaybe<SymbolStyleInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TriggerGeotiffProcessingCompleteInput = {
  datasetId: Scalars['ID']['input'];
  subscriptionId: Scalars['ID']['input'];
};

export type TriggerGeotiffProcessingCompleteResults = {
  datasetId: Scalars['ID']['output'];
  subscriptionId: Scalars['ID']['output'];
};

export type TriggerGeotiffProcessingErrorInput = {
  devError: Scalars['String']['input'];
  error: Scalars['String']['input'];
  subscriptionId: Scalars['ID']['input'];
};

export type TriggerGeotiffProcessingErrorResults = {
  devError: Scalars['String']['output'];
  error: Scalars['String']['output'];
  subscriptionId: Scalars['ID']['output'];
};

export type UpdateAccountInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<AccountPaymentMethodInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subscription?: InputMaybe<AccountSubscriptionInput>;
};

export type UpdateDatasetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupsAccesses?: InputMaybe<Array<DatasetGroupsAccessInput>>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  isSyncActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tempDatasetId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateLayerGroupInput = {
  id: Scalars['ID']['input'];
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateLayerInput = {
  bubbleStyle?: InputMaybe<BubbleConfigsInput>;
  dataType?: InputMaybe<GEOMETRY_TYPE>;
  datasetId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  heatMapStyle?: InputMaybe<HeatMapConfigsInput>;
  id: Scalars['ID']['input'];
  labelsStyle?: InputMaybe<LabelsConfigsInput>;
  layerGroupId?: InputMaybe<Scalars['ID']['input']>;
  lineCategoryStyle?: InputMaybe<LineCategoryConfigsInput>;
  lineQuantityStyle?: InputMaybe<LineQuantityConfigsInput>;
  lineSimpleStyle?: InputMaybe<LineSimpleConfigsInput>;
  maxZoom?: InputMaybe<Scalars['Float']['input']>;
  minZoom?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pointCategoryStyle?: InputMaybe<PointCategoryConfigsInput>;
  pointQuantityStyle?: InputMaybe<PointQuantityConfigsInput>;
  pointSimpleStyle?: InputMaybe<PointSimpleConfigsInput>;
  polygonCategoryStyle?: InputMaybe<PolygonCategoryConfigsInput>;
  polygonQuantityStyle?: InputMaybe<PolygonQuantityConfigsInput>;
  polygonSimpleStyle?: InputMaybe<PolygonSimpleConfigsInput>;
  styleType?: InputMaybe<LAYER_STYLE_TYPE>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMapInput = {
  baseMapId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  embedConfigs?: InputMaybe<MapEmbedConfigInput>;
  groupsAccesses?: InputMaybe<Array<MapGroupsAccessInput>>;
  id: Scalars['ID']['input'];
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publicAccessConfigs?: InputMaybe<MapPublicAccessConfigInput>;
};

export type UpdateSubscriptionAccountInput = {
  id: Scalars['ID']['input'];
  paidConfig: AccountSubscriptionPaidConfigInput;
};

export type UpdateUserGroupInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  _userGroupMembers: Array<UserGroupMember>;
  cognitoId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActivated: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type UserGroup = {
  _userGroupMembers: Array<UserGroupMember>;
  accountId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type UserGroupMember = {
  _user: User;
  _userGroup: UserGroup;
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  userGroupId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export type CreateMapMutationVariables = Exact<{
  input: CreateMapInput;
}>;


export type CreateMapMutation = { createMap: { id: string, name: string, description?: string | null } };

export type GetMapsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMapsQuery = { getMaps: Array<{ id: string, createdAt: string, updatedAt: string, name: string, description?: string | null }> };


export const CreateMapDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMap"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateMapInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMap"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<CreateMapMutation, CreateMapMutationVariables>;
export const GetMapsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMaps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMaps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<GetMapsQuery, GetMapsQueryVariables>;